import type { NumericFormatProps } from "react-number-format";
import { NumericFormat, numericFormatter } from "react-number-format";
import { getDefaultNumericFormatterProps } from "./getDefaultNumericFormatterProps";
import { roundWithPrecision } from "./roundWithPrecision";

export type RoundedNumberFormatProps = NumericFormatProps;

function RoundedNumberFormat({ value, ...other }: RoundedNumberFormatProps) {
  let roundedValue = value;

  if (value && value !== "" && Math.abs(Number(value)) < 1e-5) {
    roundedValue = 0;
  }

  let numericValue = roundedValue ? Number(roundedValue) : roundedValue;

  if (
    other.displayType === "text" &&
    typeof other.decimalScale === "number" &&
    typeof numericValue === "number"
  ) {
    numericValue = roundWithPrecision(numericValue, other.decimalScale);
  }

  return (
    <NumericFormat
      decimalSeparator=","
      thousandSeparator="."
      value={numericValue}
      {...other}
    />
  );
}

function roundedNumericFormatter(
  value: string | number | null | undefined,
  props?: NumericFormatProps
) {
  const numericFormatterProps = getDefaultNumericFormatterProps(props);
  const decimalScale = numericFormatterProps.decimalScale ?? 2;

  if (value === null || value === undefined) {
    return "";
  }

  let roundedValue = value;

  if (value && value !== "" && Math.abs(Number(value)) < 1e-5) {
    roundedValue = 0;
  }

  return numericFormatter(
    String(roundWithPrecision(Number(roundedValue), decimalScale)),
    numericFormatterProps
  );
}

export { RoundedNumberFormat, roundedNumericFormatter };
